<div class="modal fade" id="modal-cadastro-fornecedor" tabindex="-1" aria-labelledby="modal-cadastro-fornecedor-label" aria-hidden="true">
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header bg-secondary text-white">
        <h5 class="modal-title text-white" id="modal-cadastro-fornecedor-label">
          <i class='bx bx-building me-2'></i>Cadastrar Fornecedor
        </h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Fechar"></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <form #fornecedorForm="ngForm" id="form-cadastro-fornecedor">

          <!-- Dados principais -->
          <div class="row">
            <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
              <label class="label-field" for="mf-nomeFantasia">Nome Fantasia <span class="text-danger">*</span></label>
              <input
                id="mf-nomeFantasia"
                name="nomeFantasia"
                #nomeFantasia="ngModel"
                type="text"
                class="form-control"
                [(ngModel)]="fornecedor.nomeFantasia"
                placeholder="Nome fantasia"
                minlength="3"
                required>
              <div *ngIf="nomeFantasia.invalid && (nomeFantasia.dirty || nomeFantasia.touched)">
                <small *ngIf="nomeFantasia.hasError('required')" class="text-danger">Campo obrigatório.</small>
                <small *ngIf="nomeFantasia.hasError('minlength')" class="text-danger">Mínimo 3 caracteres.</small>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
              <label class="label-field" for="mf-razaoSocial">Razão Social <span class="text-danger">*</span></label>
              <input
                id="mf-razaoSocial"
                name="razaoSocial"
                #razaoSocial="ngModel"
                type="text"
                class="form-control"
                [(ngModel)]="fornecedor.razaoSocial"
                placeholder="Razão social"
                minlength="3"
                required>
              <div *ngIf="razaoSocial.invalid && (razaoSocial.dirty || razaoSocial.touched)">
                <small *ngIf="razaoSocial.hasError('required')" class="text-danger">Campo obrigatório.</small>
                <small *ngIf="razaoSocial.hasError('minlength')" class="text-danger">Mínimo 3 caracteres.</small>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
              <label class="label-field" for="mf-cnpj">CNPJ <span class="text-danger">*</span></label>
              <input
                id="mf-cnpj"
                name="cnpj"
                #cnpj="ngModel"
                type="text"
                class="form-control"
                [(ngModel)]="fornecedor.cnpj"
                mask="00.000.000/0000-00"
                [dropSpecialCharacters]="false"
                placeholder="00.000.000/0000-00"
                appCnpjValidator
                required>
              <div *ngIf="cnpj.invalid && (cnpj.dirty || cnpj.touched)">
                <small *ngIf="cnpj.hasError('required')" class="text-danger">Campo obrigatório.</small>
                <small *ngIf="cnpj.hasError('cnpjInvalid')" class="text-danger">CNPJ inválido.</small>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
              <label class="label-field" for="mf-responsavel">Resp. Fornecedor <span class="text-danger">*</span></label>
              <input
                id="mf-responsavel"
                name="responsavel"
                #responsavel="ngModel"
                type="text"
                class="form-control"
                [(ngModel)]="fornecedor.responsavel"
                placeholder="Nome do responsável"
                required>
              <div *ngIf="responsavel.invalid && (responsavel.dirty || responsavel.touched)">
                <small *ngIf="responsavel.hasError('required')" class="text-danger">Campo obrigatório.</small>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
              <label class="label-field" for="mf-telefone">Telefone</label>
              <input
                id="mf-telefone"
                name="telefone"
                type="text"
                class="form-control"
                [(ngModel)]="fornecedor.telefone"
                mask="(00) 0000-0000||(00) 00000-0000"
                [dropSpecialCharacters]="false"
                placeholder="(00) 0000-0000">
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
              <label class="label-field" for="mf-celular">Celular</label>
              <input
                id="mf-celular"
                name="telefoneCelular"
                type="text"
                class="form-control"
                [(ngModel)]="fornecedor.telefoneCelular"
                mask="(00) 00000-0000"
                [dropSpecialCharacters]="false"
                placeholder="(00) 00000-0000">
            </div>

            <div class="col-lg-3 col-md-6 col-sm-12 mb-3">
              <label class="label-field">Ativo</label>
              <div class="d-flex gap-3 mt-1">
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="ativo" id="mf-ativoSim" [value]="true" [(ngModel)]="fornecedor.ativo">
                  <label class="form-check-label" for="mf-ativoSim">Sim</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" name="ativo" id="mf-ativoNao" [value]="false" [(ngModel)]="fornecedor.ativo">
                  <label class="form-check-label" for="mf-ativoNao">Não</label>
                </div>
              </div>
            </div>
          </div>

          <!-- Endereço -->
          <hr>
          <div class="d-flex align-items-center mb-3">
            <i class='bx bx-map me-2 text-secondary'></i>
            <strong class="text-secondary">Endereço</strong>
          </div>

          <div class="row">
            <div class="col-lg-2 col-md-3 col-sm-12 mb-3">
              <label class="label-field" for="mf-cep">CEP <span class="text-danger">*</span></label>
              <input
                id="mf-cep"
                name="cep"
                #cep="ngModel"
                type="text"
                class="form-control"
                [(ngModel)]="fornecedor.cep"
                mask="00000-000"
                [dropSpecialCharacters]="false"
                placeholder="00000-000"
                (blur)="buscarCep()"
                required>
              <div *ngIf="cep.invalid && (cep.dirty || cep.touched)">
                <small *ngIf="cep.hasError('required')" class="text-danger">Campo obrigatório.</small>
              </div>
              <small *ngIf="cepInvalido" class="text-warning">CEP não encontrado ou inválido.</small>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
              <label class="label-field" for="mf-logradouro">Logradouro <span class="text-danger">*</span></label>
              <input
                id="mf-logradouro"
                name="logradouro"
                #logradouro="ngModel"
                type="text"
                class="form-control"
                [(ngModel)]="fornecedor.logradouro"
                placeholder="Logradouro"
                required>
              <div *ngIf="logradouro.invalid && (logradouro.dirty || logradouro.touched)">
                <small *ngIf="logradouro.hasError('required')" class="text-danger">Campo obrigatório.</small>
              </div>
            </div>

            <div class="col-lg-2 col-md-3 col-sm-12 mb-3">
              <label class="label-field" for="mf-numero">Número <span class="text-danger">*</span></label>
              <input
                id="mf-numero"
                name="numero"
                #numero="ngModel"
                type="text"
                class="form-control"
                [(ngModel)]="fornecedor.numero"
                placeholder="Nº"
                required>
              <div *ngIf="numero.invalid && (numero.dirty || numero.touched)">
                <small *ngIf="numero.hasError('required')" class="text-danger">Campo obrigatório.</small>
              </div>
            </div>

            <div class="col-lg-4 col-md-3 col-sm-12 mb-3">
              <label class="label-field" for="mf-complemento">Complemento</label>
              <input
                id="mf-complemento"
                name="complemento"
                type="text"
                class="form-control"
                [(ngModel)]="fornecedor.complemento"
                placeholder="Apto, bloco, etc.">
            </div>

            <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
              <label class="label-field" for="mf-bairro">Bairro <span class="text-danger">*</span></label>
              <input
                id="mf-bairro"
                name="bairro"
                #bairro="ngModel"
                type="text"
                class="form-control"
                [(ngModel)]="fornecedor.bairro"
                placeholder="Bairro"
                required>
              <div *ngIf="bairro.invalid && (bairro.dirty || bairro.touched)">
                <small *ngIf="bairro.hasError('required')" class="text-danger">Campo obrigatório.</small>
              </div>
            </div>

            <div class="col-lg-4 col-md-6 col-sm-12 mb-3">
              <label class="label-field" for="mf-cidade">Cidade <span class="text-danger">*</span></label>
              <input
                id="mf-cidade"
                name="cidade"
                #cidade="ngModel"
                type="text"
                class="form-control"
                [(ngModel)]="fornecedor.cidade"
                placeholder="Cidade"
                required>
              <div *ngIf="cidade.invalid && (cidade.dirty || cidade.touched)">
                <small *ngIf="cidade.hasError('required')" class="text-danger">Campo obrigatório.</small>
              </div>
            </div>

            <div class="col-lg-2 col-md-6 col-sm-12 mb-3">
              <label class="label-field" for="mf-estado">Estado <span class="text-danger">*</span></label>
              <select
                id="mf-estado"
                name="estado"
                #estado="ngModel"
                class="form-select"
                [(ngModel)]="fornecedor.estado"
                required>
                <option value="">Selecione</option>
                <option value="AC">Acre</option>
                <option value="AL">Alagoas</option>
                <option value="AP">Amapá</option>
                <option value="AM">Amazonas</option>
                <option value="BA">Bahia</option>
                <option value="CE">Ceará</option>
                <option value="DF">Distrito Federal</option>
                <option value="ES">Espírito Santo</option>
                <option value="GO">Goiás</option>
                <option value="MA">Maranhão</option>
                <option value="MT">Mato Grosso</option>
                <option value="MS">Mato Grosso do Sul</option>
                <option value="MG">Minas Gerais</option>
                <option value="PA">Pará</option>
                <option value="PB">Paraíba</option>
                <option value="PR">Paraná</option>
                <option value="PE">Pernambuco</option>
                <option value="PI">Piauí</option>
                <option value="RJ">Rio de Janeiro</option>
                <option value="RN">Rio Grande do Norte</option>
                <option value="RS">Rio Grande do Sul</option>
                <option value="RO">Rondônia</option>
                <option value="RR">Roraima</option>
                <option value="SC">Santa Catarina</option>
                <option value="SP">São Paulo</option>
                <option value="SE">Sergipe</option>
                <option value="TO">Tocantins</option>
              </select>
              <div *ngIf="estado.invalid && (estado.dirty || estado.touched)">
                <small *ngIf="estado.hasError('required')" class="text-danger">Campo obrigatório.</small>
              </div>
            </div>
          </div>

        </form>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" [disabled]="isSaving"><i class='bx bx-x me-1'></i>Cancelar</button>
        <button
          type="submit"
          class="btn btn-success"
          form="form-cadastro-fornecedor"
          (click)="onSubmit(fornecedorForm)"
          [disabled]="isSaving"><i class='bx bx-check-circle me-1'></i>
          <span *ngIf="isSaving" class="spinner-border spinner-border-sm me-1" role="status"></span>
          Salvar
        </button>
      </div>

    </div>
  </div>
</div>
